import styled from 'styled-components';
import DefaultTab from 'components/Tab';
import StickyHeader from 'components/StickyHeader';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div``;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled(StickyHeader)`
  justify-content: flex-start;
`;

// TODO: TFR-44 move to container group
export const Tab = styled(DefaultTab)`
  :not(:last-child) {
    margin-right: 1rem;
  }
`;
